<template>
  <v-container
    id="cargo-forms"
    fluid
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-file-document-multiple"
      inline
      class="px-5 py-3"
      title="Tipos de Contrato"
    >
      <template v-slot:after-title>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#ac8a2e"
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                large
                color="#ac8a2e"
              >
                mdi-text-box-plus
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <validation-observer v-slot="{ handleSubmit }">
                  <form
                    id="altaTipoContrato"
                    @submit.prevent="handleSubmit(validateForm)"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <validation-provider v-slot="{ errors }" name="cargo" rules="max:30|required">
                          <v-text-field
                            v-model="dataForm.descripcion"
                            color="#ac8a2e"
                            :error-messages="errors"
                            name="input-6-1"
                            label="Cargo"
                          />
                        </validation-provider>
                      </v-col>
                      <v-row
                        justify="space-around"
                      >
                        <v-checkbox
                          v-model="dataForm.club_sn"
                          class="pa-0 ml-0"
                          :value="dataForm.club_sn"
                        >
                          <span
                            slot="label"
                            class="black--text"
                          >
                            Club
                          </span>
                        </v-checkbox>
                        <v-checkbox v-model="dataForm.sponsor_sn" class="pa-0 mr-0" :value="dataForm.sponsor_sn">
                          <span slot="label" class="black--text">
                            Sponsor
                          </span>
                        </v-checkbox>
                        <v-checkbox v-model="dataForm.superpone_vigencia_sn" class="pa-0 mr-0" :value="dataForm.superpone_vigencia_sn">
                          <span slot="label" class="black--text">
                            Permitir superposición
                          </span>
                        </v-checkbox>
                      </v-row>
                    </v-row>
                  </form>
                </validation-observer>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    form="altaTipoContrato"
                    type="submit"
                    @click="dialog = false"
                  >
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="tiposContrato"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:[`item.club_sn`]="{ item }">
          <v-icon
            v-if="item.club_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-slot:[`item.sponsor_sn`]="{ item }">
          <v-icon
            v-if="item.sponsor_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template
          v-if="$can('M_parametros')"
          v-slot:[`item.actions`]="{ item }"
        >
          <v-tooltip
            content-class="top"
            top
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip
            content-class="top"
            top
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        dialog: false,
        search: undefined,
        headers: [
          {
            text: 'Descripcion',
            sortable: false,
            value: 'descripcion',
          },
          { text: 'Club', value: 'club_sn' },
          { text: 'Sponsor', value: 'sponsor_sn' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        tiposContrato: [],
        editedIndex: -1,
        dataForm: {
          id: '',
          descripcion: '',
          club_sn: '',
          sponsor_sn: '',
          superpone_vigencia_sn: '',
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo cargo' : 'Editar cargo'
      },
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.getTiposContrato()
    },
    methods: {
      mymetodo (val) {
        return ['myclase']
      },
      getTiposContrato: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_contrato_get' }).then(response => { this.tiposContrato = response })
      },

      editItem (item) {
        this.editedIndex = this.tiposContrato.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/tipo_contrato_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Cargo eliminado exitosamente'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getTiposContrato()
      },

      validateForm (scope) {
        this.enviarTipoContrato()
      },

      enviarTipoContrato: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/tipo_contrato_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.getTiposContrato()
          this.close()
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
